export { default } from "./WrongAnswerIcon";
